import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.white,
  secondaryBgColor: colors.black,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default imageSlider;